import {isNil} from 'ramda';

import {Nullish} from 'shared/web';

/**
 * Serializes query params with arrays in bracket notation (`make[]=BMW&make[]=AUDI`), which is the
 * backend's standard for repeated values. RTK's `fetchBaseQuery` has no params serializer
 * configured, so an array passed through `params` would reach the wire comma-joined into a single
 * value instead.
 *
 * The brackets are percent-encoded (`make%5B%5D=`) as the URI spec requires; every framework
 * decodes that back to `make[]` before parsing.
 */
export function buildBracketSearchParams(
  params: Record<string, string | number | string[] | Nullish>
): string {
  const searchParams = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (isNil(value)) {
      return;
    }

    if (Array.isArray(value)) {
      value.forEach((item) => searchParams.append(`${key}${ARRAY_KEY_SUFFIX}`, item));
    } else {
      searchParams.append(key, value.toString());
    }
  });

  return searchParams.toString();
}

const ARRAY_KEY_SUFFIX = '[]';
